define('views/modules/profile/blocks/personal-info',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    'services/events/user-events',
    // views
    'views/parts/info-section',
    'views/modules/profile/edit/personal-info-edit-panel',
    'views/parts/modal/image-modal',
    // templates
    'text!templates/modules/profile/blocks/personal-info.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    UserEvents,
    // views
    VInfoSection,
    VPersonalInfoEditPanel,
    VImageModal,
    // templates
    TPersonalInfo
) {

    var VPersonalInfo = Backbone.Epoxy.View.extend({
        template: TPersonalInfo,

        events: {
            'click #profile-picture': 'onProfilePictureClick',
            'click .edit-button': 'onProfilePictureClick'
        },

        initialize: function(opt) {
            this.view = {
                info: new VInfoSection({
                    title: "Personal information",
                    icon: "sl-icon-user",
                    //help: "messages:helpbox-personal-info-view",
                    buttonBottom: {
                        text: "Edit your profile or password",
                        context: this,
                        callback: this.onEditProfileInfos
                    },
                    content: this.template
                })
            };

        },

        render: function() {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext(_.extend(this.model.toJSON(), { computedLanguage: this.model.get('computedLanguage') })));

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        showPictureModal: function() {
            var view = this.view.modal;
            if (!view) {
                this.view.modal = view = new VImageModal({
                    title: "Upload a profile picture",
                    context: this,
                    callback: this.onProfilePictureChange,
                    cropper: {
                        aspectRatio: 1
                    }
                });
            }
            view.show();
        },

        ////////////
        // events //
        ////////////

        onEditProfileInfos: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.edit || (view.edit = new VPersonalInfoEditPanel({ model: this.model, }));
            this.trigger('panel:stack', panel);
        },

        onProfilePictureClick: function(e) {
            this.showPictureModal();
        },

        onProfilePictureChange: function(confirmed, blob, modal) {

            Backbone.$('#profile-picture').attr('src', 'assets/images/spinner.gif');

            if (confirmed && blob) {
                var start = new Date().getTime();
                this.model.save({ picture: blob }, {
                    patch: true,
                    success: function(model) {
                        UserEvents.profileUpdate(model, {
                            attributes: 'picture'
                        });
                    }
                });
            }
        },

    });

    return VPersonalInfo;

});

